import React from 'react';
//components
import Header from './components/Header';
import Footer from './components/Footer';
//pages
import Home from './pages/Home';
import RoomDetails from './pages/RoomDetails';

//react router
import { createBrowserRouter, RouterProvider, Route } from 'react-router-dom';

const router = createBrowserRouter([
  {
    path: '/',
    element:<Home />,
  },
  {
    path: '/apartment/:id',
    element: <RoomDetails />,
  },
]);

const isHomePage = window.location.pathname === '/';

const App = () => {
  return (<>
  <Header currentPage={isHomePage ? 'Home' : 'RoomDetails'}/>
  <RouterProvider router = {router} />
  <Footer />
  </>);
};

export default App;
